import Vue from 'vue'

const state = {
  chartsObj: null,
  showCityNumber: 5,
  showCount: 0,
  isLoading: true
}

const getters = {}

const actions = {
  drawMap ({state, commit}, {key1, key2}) {
    let paleData = key1
    state.chartsObj = null
    let chartsObj = key2
    state.chartsObj = chartsObj

    console.log(paleData)

    // let paleData = () => {
    //   let arr = []
    //   // let len = 200
    //  // console.log('length:' + len)
    //   for (var len = 0; len < 100; len++) {
    //     let geoCoord = coo[data[len].name]
    //     console.log(data[len].name)
    //     if (geoCoord) {
    //       arr.push({
    //         name: data[len].name,
    //         value: geoCoord.concat(data[len].value)
    //       })
    //     }
    //   }
    //   return arr
    // }
    // console.log(paleData)
    // let lightData = paleData.sort((a, b) => {
    //   return b.value - a.value
    // }).slice(0 + state.showCount, state.showCityNumber + state.showCount)
    if (state.isLoading) {
      chartsObj.hideLoading()
      commit('closeLoading')
    }
    chartsObj.setOption({
      backgroundColor: '#272D3A',
      // 标题
      title: {
        text: '中国地图闪闪发光',
        left: 'center',
        textStyle: {
          color: '#fff'
        }
      },
      // 地图上圆点的提示
      tooltip: {
        trigger: 'item',
        formatter: function (params) {
          return params.name + ' : ' + params.value[2]
        }
      },
      // 图例按钮 点击可选择哪些不显示
      legend: {
        orient: 'vertical',
        left: 'left',
        top: 'bottom',
        data: ['Crops'],
        textStyle: {
          color: '#fff'
        }
      },
      // 地理坐标系组件
      geo: {
        map: 'liberia',
        label: {
          // true会显示城市名
          emphasis: {
            show: false
          }
        },
        itemStyle: {
          // 地图背景色
          normal: {
            areaColor: '#465471',
            borderColor: '#282F3C'
          },
          // 悬浮时
          emphasis: {
            areaColor: '#8796B4'
          }
        }
      },
      // 系列列表
      series: [
        {
          name: 'Crops2',
          // 表的类型 这里是散点
          type: 'scatter',
          // 使用地理坐标系，通过 geoIndex 指定相应的地理坐标系组件
          coordinateSystem: 'geo',
          data: paleData,
          // 标记的大小
          symbolSize: 12,
          // 鼠标悬浮的时候在圆点上显示数值
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              color: '#ddb926'
            },
            // 鼠标悬浮的时候圆点样式变化
            emphasis: {
              borderColor: '#fff',
              borderWidth: 1
            }
          }
        }
      ]
    })
    commit('addCount')
    console.log(chartsObj)
    chartsObj.resize()
  },

  SET_ECHART: (context, eC) => {
    context.commit('SET_E_CHART', eC)
  }

}

const mutations = {
  SET_E_CHART: (state, eC) => {
    Vue.set(state, 'chartsObj', eC)
  },
  closeLoading (state) {
    state.isLoading = false
  },
  openLoading (state) {
    state.isLoading = true
  },
  addCount (state) {
    state.showCount++
    // test
    if (state.showCount >= 70) {
      state.showCount = 1
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
